export default [{
        path: '/material-master-data',
        name: 'materialMasterData',
        component: () =>
            import ('@/components/page/material/material-master-data/material-master-data'),
        meta: { title: 'nav.materialMasterData' },
    },
    {
        path: '/materialGRI',
        component: () =>
            import ('@/components/page/material/material-master-data/materialGRI'),
        meta: { title: 'nav.materialGRI' },
    },
    {
        path: '/materialGRIDetail',
        component: () =>
            import ('@/components/page/material/material-master-data/materialGRIDetail'),
        meta: { title: 'material.materialGRIDetail' },
    },
    {
        path: '/materialGRIC1',
        component: () =>
            import ('@/components/page/material/material-master-data/materialGRIC1'),
        meta: { title: 'nav.materialGRIC1' },
    },
    {
        path: '/materialGRIC2',
        component: () =>
            import ('@/components/page/material/material-master-data/materialGRIC2'),
        meta: { title: 'nav.materialGRIC2' },
    },
    {
        path: '/material-master-add',
        name: 'materialMasterAdd',
        component: () =>
            import ('@/components/page/material/material-master-data/material-master-add'),
        meta: { title: 'nav.material' },
    },
]